module.exports = __webpack_public_path__ + "static/media/boy-5.4156ed46.svg";